namespace GeniuzPOS.InitialData {
    export class PsCreditCardColumns {
        static columnsKey = 'InitialData.PsCreditCard';
    }
}
